import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * Anzen sUSDz (Staked USDz) — intrinsic yield.
 *
 * Sourced from DefiLlama's `anzen-v2` pool (Ethereum). APY → APR per
 * pipeline convention. Emitted under every assetGroup the classifier
 * assigns sUSDz across chains (case + display-name variants).
 */
const SUSDZ_POOL_ID = '46518e93-8197-4539-9861-2340c2ac965a'

const KEYS = ['Anzen Staked USDz::SUSDZ', 'Anzen Staked USDz::sUSDz', 'Staked USDz::sUSDz']

export const susdzFetcher: YieldFetcher = {
  label: 'SUSDZ',
  fetch: async () => {
    const apr = apyToAprPercent(await fetchDefiLlamaApy(SUSDZ_POOL_ID))
    return Object.fromEntries(KEYS.map((k) => [k, apr]))
  },
}
